import React, { Fragment, useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Spinner from '../layout/Spinner';
import { setAlert } from '../../actions/alert';
import {
  logoutVS,
  getInstanceById,
  updateInstanceExpirationDate
} from '../../actions/virtualscreen';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { TiExportOutline } from 'react-icons/ti';
import ExportCalib from './ExportCalib';

const VirtualScreen = ({
  getInstanceById,
  data,
  logoutVS,
  updateInstanceExpirationDate
}) => {
  const { t } = useTranslation();
  const [showButtonLogout, setShowButtonLogout] = useState(false);
  const [showButtonExport, setShowButtonExport] = useState(false);

  const { id } = useParams();
  useEffect(() => {
    getInstanceById(id);
  }, [getInstanceById, id]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButtonLogout(true);
    }, 1000); // Affiche le bouton après 1 seconde

    return () => clearTimeout(timer); // Nettoie le timer
  }, []);

  useEffect(() => {
    let inactivityTimer;

    const startInactivityTimer = () => {
      inactivityTimer = setTimeout(async () => {
        console.log("Déconnexion après 1 heure d'inactivité");
        await logoutVS(data?.name, id);
        window.close();
      }, 60 * 60 * 1000); // 1 heure en millisecondes
    };

    const resetInactivityTimer = () => {
      if (inactivityTimer) clearTimeout(inactivityTimer);
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        startInactivityTimer(); // Démarrer le timer si l'onglet devient invisible
      } else {
        resetInactivityTimer(); // Annuler la déconnexion si l'utilisateur revient
      }
    };

    const handleBeforeUnload = async () => {
      await logoutVS(data?.name, id); // Déconnexion si l'onglet ou le navigateur est fermé
    };

    const handleUnload = async () => {
      await logoutVS(data?.name, id);
    };

    window.addEventListener('unload', handleUnload);
    window.addEventListener('beforeunload', handleBeforeUnload);
    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      clearTimeout(inactivityTimer);
      window.removeEventListener('unload', handleUnload);
      window.removeEventListener('beforeunload', handleBeforeUnload);
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [logoutVS, data, id]);

  const DeconnexionEcranVirtuelle = async (name) => {
    if (window.confirm(t('logout_confirm'))) {
      const res = await logoutVS(name, id);
      if (res?.status === 200) {
        setAlert(t('logout_alert'), 'danger');
        window.close();
      }
    }
  };

  useEffect(() => {
    const timer = setInterval(() => {
      updateInstanceExpirationDate(id);
    }, 2000);
    return () => clearInterval(timer);
  }, [id, updateInstanceExpirationDate]);

  return (
    <section className="container">
      <Fragment>
        <div className="parent-flex">
          <div
            className={`child-left-auto mb-2  ${
              data === null ? 'zposbtn' : ''
            }`}
          >
            {showButtonLogout && (
              <div>
                <button
                  className="logout-btn"
                  onClick={() => DeconnexionEcranVirtuelle(data.name)}
                >
                  {t('logout')}
                </button>
                <button
                  onClick={() => setShowButtonExport(!showButtonExport)}
                  className="export-btn"
                >
                  <TiExportOutline />
                </button>
              </div>
            )}
          </div>
        </div>
        <div>
          <div className="fullscreen-bandeau">
            <p className="lead bg-ascorel p-4 text-center">
              {t('launching_instance')}
            </p>
            <Spinner />
          </div>
          {data !== null ? (
            <>
              <div
                className={`iframe-container ${
                  showButtonExport ? 'split' : ''
                }`}
              >
                <iframe
                  title="virtual Screen MC603"
                  className="iframe"
                  src={data.url}
                ></iframe>

                <div
                  style={{
                    display: showButtonExport ? 'block' : 'none'
                  }}
                >
                  <ExportCalib
                    className="iframe"
                    iframe={data.url}
                    port_calib_downloader={data.port_calib_downloader}
                  />
                </div>
              </div>
            </>
          ) : (
            <div> </div>
          )}
        </div>
      </Fragment>
    </section>
  );
};

VirtualScreen.propTypes = {
  logoutVS: PropTypes.func.isRequired,
  getInstanceById: PropTypes.func.isRequired,
  updateInstanceExpirationDate: PropTypes.func.isRequired,
  data: PropTypes.object
};

const mapStateToProps = (state) => ({
  data: state.virtualscreen.data
});

export default connect(mapStateToProps, {
  logoutVS,
  getInstanceById,
  updateInstanceExpirationDate
})(VirtualScreen);
